import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';

export const useCreateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likedFolderService.post,
    throwOnError: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.getInfiniteLikeFolders,
      });
    },
  });
};
